<template>
  <v-col cols="12" :sm="blockType === 'gadgets' ? 12 : 6"
         class="text-center pa-3" :style="{color: color}"
  >
    <span class="text-overline text-uppercase pointer"
          :style="{color: color}"
          @click="$router.push(blockTitle.link)"
    >
      {{ blockTitle[blockType] }}
    </span>
    <v-divider :style="{borderColor:color}"/>
    <div class="arrowDown" :style="{borderTop: '6px solid ' + color}"></div>
    <v-row>
      <v-col cols="6" :sm="blockType === 'gadgets' ? 3 : 6"
             v-for="(product, index) in productsLists" :key="'product_'+product.id"
             class="pa-2">
        <ProductTileNew :product="product" v-if="!(showVideoTile && index===3)"/>
      </v-col>
      <v-col cols="6" sm="6" class="pa-2 mt-3" v-if="showVideoTile && !$vuetify.breakpoint.mobile">
        <VideoTile/>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ProductTileNew from '@/components/Partials/ShopBody/ProductTileNew.vue';
import Axios from '@/core/Axios';
import VideoTile from '@/components/Partials/ShopBody/VideoTile.vue';

export default {
  name: 'ProductsBlock',
  components: { VideoTile, ProductTileNew },
  props: ['blockType', 'color', 'showVideoTile', 'conditions'],
  data() {
    return {
      axios: new Axios(),
      productsLists: null,
    };
  },
  mounted() {
    this.getProductList(this.conditions, this.blockType);
  },
  computed: {
    blockTitle() {
      return this.$store.state.text.pages.main.find((v) => v[this.blockType]);
    },
  },
  methods: {
    getProductList(conditions) {
      this.axios.makeCall('POST', 'norbit/mainpageproducts', { conditions: JSON.stringify(conditions) })
        .then((response) => {
          this.productsLists = response;
        });
    },
  },
};
</script>

<style scoped>
.arrowDown {
  width: 0;
  height: 0;
  margin-left: 49.5%;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
</style>
